import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import './_blurb.scss';

const Blurb = props => {
    const { text, modifiers } = props;

    return (
        <div className={classNames('blurb', modifiers.map(modifier => `blurb--${modifier}`))}>
            {text}
        </div>
    );
};

Blurb.propTypes = {
    text: propTypes.string.isRequired,
    modifiers: propTypes.array,
};

Blurb.defaultProps = {
    text: '',
    modifiers: [],
};

export default Blurb;
